import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { useAccounts } from "./useAccounts";

export function useManualJournalAccounts(
    entityId?: number,
    ledgerBasis?: AccountingLedgerBasis,
) {
    return useAccounts({
        entityId,
        ledgerBasis,
        includeDisabled: true,
    });
}
